<template>
    <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span class="text-center">Tax Info for Invoice </span>
            </v-card-title>

            <v-divider></v-divider>

            <!-- <v-card-subtitle class="px-4 pt-4">
                <h2>Details</h2>
            </v-card-subtitle> -->

            <v-card-text>
                <v-form @submit.prevent="submit" ref="ProposalLogForm">
                <v-row>
                    <v-col cols="12">

                        <v-text-field
                            density="compact"
                            variant="outlined" 
                            bg-color="grey-lighten-4"
                            label="Container No"
                            v-model="container_no.value.value"
                            :error-messages="container_no.errorMessage.value"
                            autocomplete="off" 
                        ></v-text-field>

                        <v-text-field
                            density="compact"
                            variant="outlined" 
                            bg-color="grey-lighten-4"
                            label="MBL No"
                            v-model="mbl_no.value.value"
                            :error-messages="mbl_no.errorMessage.value"
                            autocomplete="off" 
                        ></v-text-field>

                         <v-text-field
                            label="HBL No"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="hbl_no.value.value"
                            :error-messages="hbl_no.errorMessage.value"
                            autocomplete="off"
                            clearable
                        >
                        </v-text-field>

                        <v-date-input
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            label="MBL / HBL Date"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="mbl_date.value.value"
                            :error-messages="mbl_date.errorMessage.value"
                            autocomplete="off"
                            clearable
                        >
                            <template #label>
                                MBL / HBL Date
                            </template>
                        </v-date-input>
                    </v-col>
                </v-row>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout class="justify-end">
                        <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                        >
                            Close
                        </v-btn>
                        <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                            {{ isEntryMode ? "Save" : "Update" }}
                        </v-btn>
                    </v-layout>
                </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import axios from "axios";
import { prefix } from "@/store/api";

export default {
    name: "taxInfoSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                container_no: "",
                mbl_no: "",
                hbl_no: "",
                mbl_date: "",
                sale_invoice_id: null,
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            selectedImage: null,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.container_no.setValue(newData.container_no || "", false);
                this.mbl_no.setValue(newData.mbl_no || "", false);
                this.hbl_no.setValue(newData.hbl_no || "", false);
                this.mbl_date.setValue(newData.mbl_date || "", false);
                this.sale_invoice_id.setValue(newData.id || "", false);
            },
        },
    },
    created() {
    },
    computed: {
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                container_no: yup.string().nullable().label("Container No"),
                mbl_no: yup.string().nullable().label("MBL No"),
                hbl_no: yup.string().nullable().label("HBL No"),
                mbl_date: yup.string().nullable().label("MBL Date"),
            }),
        });
        
        const sale_invoice_id = useField("sale_invoice_id");
        const container_no = useField("container_no");
        const mbl_no = useField("mbl_no");
        const hbl_no = useField("hbl_no");
        const mbl_date = useField("mbl_date");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            values.mbl_date = formattedDate(mbl_date.value.value);
            store.commit("SET_LOADING", {color: "primary"});
            axios.post(prefix + "sales/update-sls-sale-invoice", values)
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    emit("update-success");
                    store.commit("UNSET_LOADING");
                    toast.success(response.data.message);

                    store.dispatch("getSaleInvoiceList", values)
                        .then((response) => {
                            loading.value = false;
                        })
                        .catch((error) => {
                            if (error.response && error.response.data && error.response.data.errors) {
                                const errors = error.response.data.errors;
                                const messages = Object.values(errors).flat().join('\n');
                                toast.error(messages);
                            } else {
                                toast.error(error.response?.data?.message || 'Something went wrong');
                            }
                        });
                })
                .catch((error) => {
                    store.commit("UNSET_LOADING");
                    toast.error(error.response?.data?.message || "Something went wrong");
                }
            );
        });

        return {
            submit,
            sale_invoice_id,
            container_no,
            mbl_no,
            mbl_date,
            hbl_no,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {
        console.log(this.props);
    },
};
</script>
